import './ContactBlock.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {SendMessage} from "../../redux/actions";
import {connect} from "react-redux";
import {PhoneDropDownIcon, TickIcon} from "../../assets/images";
import {InputGroup} from "../ui-elements/input-group/inputGroup";
import {LoadingOutlined} from "@ant-design/icons";
import {useState} from "react";
import {Link} from "react-router-dom";
import {Checkbox} from "antd";
import MapModal from "../modal/mapModal/MapModal";
import { PrimaryButton } from "../ui-elements/buttons/Buttons";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";

function ContactBlock(props) {
    const {requestLoading, contact, staticTexts, selectedLanguage} = props
    const [loading, setLoading] = useState(false)
    const [checked, setChecked] = useState(false)
    const [status, setStatus] = useState('')
    const [visible, setVisible] = useState(false)
    const [fieldsData, setFieldsData] = useState({
        name: "",
        phone: "",
        message: "",
    })
    const [errors, setErrors] = useState({
        name: "",
        phone: "",
        message: "",
        checked: false,
    })

    const showTick = () => {
        setTimeout(
            () => {
                setErrors({
                    name: "",
                    phone: "",
                    message: "",
                    checked: "",
                })
                setFieldsData({
                    name: "",
                    phone: "",
                    message: "",
                })
                setStatus('')
            },
            2000,
        )
    }

    function closeModal() {
        setVisible(!visible)
    }

    function getInputValues(e) {
        const {name, value} = e.target
        if (name === "phone" && value && !/^[+\d]\d*$/.test(value)) {
            return
        }
        setFieldsData({
            ...fieldsData,
            [name]: value
        })

        setErrors({
            ...errors,
            [name]: false,
        })
    }

    function validate() {
        const errors = {};
        let result = true;
        Object.keys(fieldsData).forEach(key => {
            if (!fieldsData[key]) {
                errors[key] = true;
                result = false;
            }
        })
        if(!checked){
            errors.checked=true;
            result=false
        }
        setErrors(errors);
        return result;
    }

    const sendMessage = () => {

        if (validate()) {
            setLoading(true)
            props.SendMessage(fieldsData).then(() => {
                setStatus('success')
                setLoading(false)
                showTick()
            }).catch(()=>{
                setStatus('error')
                setLoading(false)
            })
        }
    }
    let title = staticTexts?.contact_block_title
    const firstIndex = title?.indexOf('%s')
    const lastIndex = title?.lastIndexOf('%s')

    if (firstIndex !== -1 && lastIndex !== -1 && firstIndex !== lastIndex) {
        title = title.replace('%s', `${firstIndex === 0 ? "": '&nbsp;'}<span>`);
        title = title.replace('%s', `</span>`);
    }
    return <div className={'ContactBlock'}>
        <div className={'contact-block'}>
            <div className={'left-block'}>
                <div className={'left-title'} dangerouslySetInnerHTML={{__html: title}}>
                </div>
                <div className={'phone-block'}>
                    <div className={'phone-title'}>
                        {staticTexts?.contact_phone_title}
                    </div>
                    <a href={`tel:+${contact?.phoneNumber}`} target={'_blank'} className={'phone'}>
                        {contact?.phoneNumber}
                    </a>
                </div>
                <div className={'address-block'}>
                    <div className={'address-title'}>
                        {staticTexts?.contact_address_title}
                    </div>
                    <div className={'address'} onClick={() => setVisible(true)}>
                        {contact?.address || 'Еревана, Проспект Тигран Мец, 72'}
                    </div>
                </div>
            </div>
            <div className={'right-block'}>
                <div className={'top-inputs'}>
                    <InputGroup
                        inputType={'input'}
                        type={"text"}
                        value={fieldsData.name}
                        error={errors.name}
                        name={'name'}
                        maxLength={30}
                        placeholder={staticTexts?.contacts_page_placeholder_name}
                        onChange={getInputValues}
                    />
                    <InputGroup
                        inputType={'input'}
                        type={"text"}
                        value={fieldsData.phone}
                        error={errors.phone}
                        name={'phone'}
                        maxLength={30}
                        placeholder={staticTexts?.contacts_page_placeholder_phoneNumber}
                        onChange={getInputValues}
                    />
                </div>
                <div className={'bottom-inputs'}>
                    <InputGroup
                        inputType={'textarea'}
                        type={"text"}
                        value={fieldsData.message}
                        error={errors.message}
                        name={'message'}
                        placeholder={staticTexts?.contacts_page_placeholder_message}
                        onChange={getInputValues}
                    />
                    <div className={'contacts-bottom'}>
                        <div className={'checkbox-block'}>
                            <Checkbox className={`checkbox-wrapper ${errors.checked ? "error": ''}`}
                                      checked={checked}
                                      onChange={()=> {
                                          errors.checked &&  setErrors({
                                              ...errors,
                                              checked: false,
                                          })
                                          setChecked(!checked)
                                      }}>
                                {staticTexts?.checkbox_text1} <Link to={getUrlWithLocal(`/privacy-policy`)} className={'checkbox-text'}>{staticTexts?.checkbox_text2}</Link>
                            </Checkbox>
                        </div>
                        <PrimaryButton
                            className={status && `bg_${status}`}
                            title={<>
                                {staticTexts?.contacts_page_btn_send_message}
                                {loading && <>&nbsp;<LoadingOutlined style={{fontSize: 14, color: "#fff"}}/></>}
                            </>}
                            cb={sendMessage}
                        />

                        {/*<button className='PrimaryButton'
                                onClick={() => {
                                    sendMessage()
                                }}
                        >
                            {staticTexts?.contacts_page_btn_send_message}
                            {
                                requestLoading ? <LoadingOutlined style={{fontSize: 14, color: "#fff"}}/>
                                    : <TickIcon title={''} className={`tick-icon ${tick ? 'show-tick' : 'hide-tick'}`}/>
                            }
                        </button>*/}
                    </div>
                </div>
            </div>
        </div>

        {
            visible && <MapModal closeModal={closeModal}
                                 visible={visible}/>
        }
    </div>

}

const mapStateToProps = (state) => getPropsFromState(state, [
    'requestLoading',
    'staticTexts',
    'about',
    'contact',
    'selectedLanguage'
]);

const mapDispatchToProps = {
    SendMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactBlock);
